import { FormTemplate, PneAppointment, SearchModel } from '@nrwl/rx-models';
import { Action } from '@ngrx/store';
import { Form } from '@nrwl/rx-models';
import { ShareLinkPayload, ShareViaPortalPayload } from '@nrwl/rx-models';

export enum AccountLibraryActionTypes {
  LoadAccountLibrary = '[AccountLibrary] Load Account Library',
  LoadAccountLibrarySuccess = '[AccountLibrary] Load Account Library Success',

  ExpandFormGroup = '[AccountLibrary] Expand Form Group',

  SelectFormTemplate = '[AccountLibrary] Select Form Template',
  SelectFormTemplateSuccess = '[AccountLibrary] Select Form Template Success',

  DeselectAllTemplates = '[AccountLibrary] Deselect All Form Templates',

  SearchForm = '[AccountLibrary] Search Content By Keyword',
  ResetSearchForm = '[AccountLibrary] Reset Search Content',

  DeleteForm = '[AccountLibrary] Delete Form',
  DeleteFormSuccess = '[AccountLibrary] Delete Form Success',

  FillSign = '[AccountLibrary] Fill And Sign Status',
  FillSignSuccess = '[AccountLibrary] Fill And Sign Status Success',
  FillSignFailure = '[AccountLibrary] Fill And Sign Status Failure',
  FillSignReset = '[AccountLibrary] Reset fill and sign',

  FinalisationFillSign = '[AccountLibrary] Finalisation Fill And Sign Status',
  FinalisationFillSignSuccess = '[AccountLibrary] Finalisation Fill And Sign Status Success',

  SetEditableTemplates = '[AccountLibrary] Set Editable Forms',
  SetEditableTemplatesSuccess = '[AccountLibrary] Set Editable Forms Success',

  SaveEditableTemplates = '[AccountLibrary] Save Editable Form',

  SetPreviewTemplate = '[AccountLibrary] Set Preview Template',
  SetPreviewTemplateSuccess = '[AccountLibrary] Set Preview Template Success',

  ShareViaPortal = '[AccountLibrary] Share Via Portal',
  ShareViaLink = '[AccountLibrary] Share Via Link',
  ShareSuccess = '[AccountLibrary] Share Via Portal Success',

  SetAppointment = '[AccountLibrary] Set Appointment',
  ClearAppointment = '[AccountLibrary] Clear Appointment',

  Error = '[AccountLibrary] Error',
}

export class LoadAccountLibrary implements Action {
  readonly type = AccountLibraryActionTypes.LoadAccountLibrary;
  constructor(public payload: number) {}
}

export class LoadAccountLibrarySuccess implements Action {
  readonly type = AccountLibraryActionTypes.LoadAccountLibrarySuccess;
  constructor(public payload: any) {}
}

export class ExpandFormGroup implements Action {
  readonly type = AccountLibraryActionTypes.ExpandFormGroup;
  constructor(public payload: string) {}
}

export class SelectFormTemplate implements Action {
  readonly type = AccountLibraryActionTypes.SelectFormTemplate;
  constructor(public payload: { form: FormTemplate; patientId: number }) {}
}

export class SelectFormTemplateSuccess implements Action {
  readonly type = AccountLibraryActionTypes.SelectFormTemplateSuccess;
  constructor(public payload: FormTemplate) {}
}

export class DeselectAllTemplates implements Action {
  readonly type = AccountLibraryActionTypes.DeselectAllTemplates;
  constructor(public payload?: any) {}
}

export class SearchForm implements Action {
  readonly type = AccountLibraryActionTypes.SearchForm;
  constructor(public payload: SearchModel) {}
}

export class ResetSearchForm implements Action {
  readonly type = AccountLibraryActionTypes.ResetSearchForm;
}

export class SetEditableTemplates implements Action {
  readonly type = AccountLibraryActionTypes.SetEditableTemplates;
  constructor(public payload: FormTemplate[]) {}
}
export class SetEditableTemplatesSuccess implements Action {
  readonly type = AccountLibraryActionTypes.SetEditableTemplatesSuccess;
  constructor(public payload: FormTemplate[]) {}
}

export class SaveEditableTemplates implements Action {
  readonly type = AccountLibraryActionTypes.SaveEditableTemplates;
  constructor(public payload: { id: number; template: string }) {}
}

export class SetPreviewTemplate implements Action {
  readonly type = AccountLibraryActionTypes.SetPreviewTemplate;
  constructor(public payload: { form: FormTemplate; patientId: number }) {}
}

export class SetPreviewTemplateSuccess implements Action {
  readonly type = AccountLibraryActionTypes.SetPreviewTemplateSuccess;
  constructor(public payload: FormTemplate) {}
}

export class FillSign implements Action {
  readonly type = AccountLibraryActionTypes.FillSign;
  constructor(
    public payload: {
      id: number;
      form_data?: any;
      data?: any;
      scribeArtifactOperationId?: string;
    },
  ) {}
}

export class FillSignSuccess implements Action {
  readonly type = AccountLibraryActionTypes.FillSignSuccess;
  constructor(
    public payload: Form,
    public readonly scribeArtifactOperationId?: string,
  ) {}
}

export class FillSignFailure implements Action {
  readonly type = AccountLibraryActionTypes.FillSignFailure;
  constructor(
    public readonly error: unknown,
    public readonly scribeArtifactOperationId?: string,
  ) {}
}

export class FillSignReset implements Action {
  readonly type = AccountLibraryActionTypes.FillSignReset;
  constructor(public payload: any) {}
}

export class FinalisationFillSign implements Action {
  readonly type = AccountLibraryActionTypes.FinalisationFillSign;
  constructor(public payload: any) {}
}

export class FinalisationFillSignSuccess implements Action {
  readonly type = AccountLibraryActionTypes.FinalisationFillSignSuccess;
  constructor(public payload: Form[]) {}
}

export class ShareViaPortal implements Action {
  readonly type = AccountLibraryActionTypes.ShareViaPortal;
  constructor(public payload: ShareViaPortalPayload) {}
}

export class ShareViaLink implements Action {
  readonly type = AccountLibraryActionTypes.ShareViaLink;
  constructor(public payload: ShareLinkPayload) {}
}

export class ShareSuccess implements Action {
  readonly type = AccountLibraryActionTypes.ShareSuccess;
  constructor(public payload: any) {}
}

export class SetAppointment implements Action {
  readonly type = AccountLibraryActionTypes.SetAppointment;
  constructor(public payload: { appointment: PneAppointment | null }) {}
}

export class ClearAppointment implements Action {
  readonly type = AccountLibraryActionTypes.ClearAppointment;
}

export class Error implements Action {
  readonly type = AccountLibraryActionTypes.Error;
  constructor(public payload: string) {}
}

export type AccountLibraryActions =
  | LoadAccountLibrary
  | LoadAccountLibrarySuccess
  | ExpandFormGroup
  | SelectFormTemplate
  | SelectFormTemplateSuccess
  | DeselectAllTemplates
  | SearchForm
  | ResetSearchForm
  | SetEditableTemplates
  | SetEditableTemplatesSuccess
  | SaveEditableTemplates
  | SetPreviewTemplate
  | SetPreviewTemplateSuccess
  | FillSign
  | FillSignSuccess
  | FillSignFailure
  | FillSignReset
  | FinalisationFillSign
  | FinalisationFillSignSuccess
  | ShareViaPortal
  | ShareViaLink
  | ShareSuccess
  | SetAppointment
  | ClearAppointment
  | Error;
